module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAAAwBAMAAABeexFrAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURdgCEgJYoc/f7e+Bi/X19QJYodl9hsUIF7PG1QhUlQhUk+EAEv///wBap98OYgMAAAALdFJOU+Xlw8Pk48Xdxd3bQ9UZFAAAAD5JREFUOMtjWBoKBxEuCJDAAAfsDLJ34eDSGQSw3g0HG0bVjKoZVTOqZlTNqBqqqVkoCAeodRM7EBYAEQM7ANVp005c6FfVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/france.png
// module id = 7MPO
// module chunks = 34